import {Route, Routes} from 'react-router-dom'
import {AllUsersPage} from '../almamotor/pages/users/AllUsersPage'
import {OneUserPage} from '../almamotor/pages/oneUser/OneUserPage'
import {ValidationsPage} from '../almamotor/pages/validations/ValidationsPage'
import {OneValidationPage} from '../almamotor/pages/oneValidation/OneValidationPage'
import {NotFoundPage} from '../almamotor/pages/notFound/NotFoundPage'

export const PrivateRoutesAlmamotor = () => {
  return (
    <Routes>
      <Route path='/users' element={<AllUsersPage />} />
      <Route path='/user/:id' element={<OneUserPage />} />
      <Route path='/validations' element={<ValidationsPage />} />
      <Route path='/validation/:id' element={<OneValidationPage />} />

      <Route path='*' element={<NotFoundPage />} />
    </Routes>
  )
}
